/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowlogotopright4Inputs */

const en_aiflowlogotopright4 = /** @type {(inputs: Aiflowlogotopright4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, top right`)
};

const de_aiflowlogotopright4 = /** @type {(inputs: Aiflowlogotopright4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, rechts oben`)
};

/**
* | output |
* | --- |
* | "Yes, top right" |
*
* @param {Aiflowlogotopright4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowlogotopright4 = /** @type {((inputs?: Aiflowlogotopright4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowlogotopright4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowlogotopright4(inputs)
	return de_aiflowlogotopright4(inputs)
});
export { aiflowlogotopright4 as "aiFlowLogoTopRight" }